<template>
    <v-card class="elevation-0 background-2 pa-3">
        <v-card-subtitle class="pa-0 pb-2 font-weight-bold">
            Storico Chiamate
        </v-card-subtitle>
        <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-2"></v-progress-linear>
        <v-simple-table v-else-if="outcomes.length > 0" dense class="background-2">
            <thead>
                <tr>
                    <th>Esito</th>
                    <th>Telefono</th>
                    <th>Descrizione</th>
                    <th>Data</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="outcome in outcomes" :key="outcome.id">
                    <td>
                        <v-chip small :color="getOutcomeColor(outcome.outcome)" dark>
                            {{ outcome.outcome ? $eventBusUtility.callqueueOutcomeText(outcome.outcome) : '-' }}
                        </v-chip>
                    </td>
                    <td>{{ outcome.telephone || '-' }}</td>
                    <td class="text-wrap" style="max-width: 400px">{{ outcome.outcome_description || '-' }}</td>
                    <td>{{ outcome.created_at | date }}</td>
                </tr>
            </tbody>
        </v-simple-table>
        <div v-else class="text--secondary text-body-2 pa-2">
            Nessun tentativo di chiamata registrato
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'callqueue-outcomes',

    props: {
        businessCallqueueId: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            outcomes: [],
            loading: true
        }
    },

    created() {
        this.loadOutcomes()
    },

    methods: {
        loadOutcomes() {
            this.loading = true
            this.axios.get('business-callqueues/' + this.businessCallqueueId + '/outcomes')
                .then(response => {
                    this.outcomes = response.data.data
                })
                .finally(() => {
                    this.loading = false
                })
        },

        getOutcomeColor(outcome) {
            return this.$eventBusUtility.callqueueOutcomeColor(outcome)
        }
    }
}
</script>
